import type { StatusBadgeProps } from "@/components/ds/StatusBadge";
type Tone = NonNullable<StatusBadgeProps["tone"]>;

export const STAGE_META: Record<string, { label: string; tone: Tone }> = {
  new: { label: "New", tone: "slate" },
  contacted: { label: "Contacted", tone: "blue" },
  qualified: { label: "Qualified", tone: "blue" },
  appointment_booked: { label: "Appointment Booked", tone: "green" },
  estimate_scheduled: { label: "Estimate Scheduled", tone: "amber" },
  won: { label: "Won", tone: "green" },
  lost: { label: "Lost", tone: "red" },
};

export const STAGE_ORDER = ["new", "contacted", "qualified", "appointment_booked", "estimate_scheduled", "won", "lost"];

export const PRIORITIES = [
  { value: "low", label: "Low" }, { value: "medium", label: "Medium" },
  { value: "high", label: "High" }, { value: "urgent", label: "Urgent" },
];
export const PRIORITY_TONE: Record<string, Tone> = { low: "slate", medium: "blue", high: "amber", urgent: "red" };

export const QUALIFICATION = [
  { value: "unqualified", label: "Unqualified" }, { value: "qualifying", label: "Qualifying" },
  { value: "qualified", label: "Qualified" }, { value: "disqualified", label: "Disqualified" },
];

export const CONTACT_METHODS = [
  { value: "phone", label: "Phone" }, { value: "sms", label: "SMS" }, { value: "email", label: "Email" },
];
export const CONSENT = [
  { value: "unknown", label: "Unknown" }, { value: "granted", label: "Granted" }, { value: "revoked", label: "Revoked" },
];

export const ACTIVITY_LABEL: Record<string, string> = {
  created: "Lead created", stage_change: "Stage changed", note: "Note added",
  assignment: "Reassigned", field_update: "Details updated", call: "Call", sms: "Text", appointment: "Appointment", ai_action: "AI action",
};

export function fmtDate(iso?: string | null): string {
  if (!iso) return "—";
  return new Date(iso).toLocaleString(undefined, { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });
}
